var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInbound = function SvgInbound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.693 7.836a.75.75 0 0 1 .812-.683c1.912.164 3.41.752 4.403 1.977.977 1.204 1.352 2.886 1.352 4.98v.13c0 2.31-.457 4.12-1.673 5.336-1.216 1.216-3.027 1.674-5.336 1.674H7.74c-2.31 0-4.121-.458-5.337-1.674C1.188 18.361.73 16.55.73 14.24v-.13c0-2.079.371-3.75 1.332-4.952.979-1.223 2.454-1.82 4.339-1.995a.75.75 0 0 1 .14 1.494c-1.656.154-2.676.648-3.307 1.438-.65.81-1.004 2.073-1.004 4.015v.13c0 2.16.438 3.479 1.235 4.276.796.797 2.115 1.234 4.275 1.234h6.51c2.161 0 3.48-.437 4.276-1.234.797-.797 1.235-2.115 1.235-4.276v-.13c0-1.956-.36-3.224-1.018-4.035-.641-.79-1.679-1.282-3.367-1.428a.75.75 0 0 1-.683-.811Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 .25a.75.75 0 0 1 .75.75v12.88a.75.75 0 0 1-1.5 0V1A.75.75 0 0 1 11 .25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.122 11.12a.75.75 0 0 1 1.06 0l2.82 2.82 2.82-2.82a.75.75 0 0 1 1.06 1.06l-3.35 3.35a.75.75 0 0 1-1.06 0l-3.35-3.35a.75.75 0 0 1 0-1.06Z",
    fill: "currentColor"
  })));
};
export default SvgInbound;